import CoreUIIcons from './CoreUIIcons';
import Flags from './Flags';
import FontAwesome from './FontAwesome';
import SimpleLineIcons from './SimpleLineIcons';
import {
  MdRefresh,
  MdOutlineSearch,
  MdOutlineRemoveRedEye,
  MdContentCopy,
  MdComputer,
  MdDriveFileMoveOutline,
  MdOutlineCheckBoxOutlineBlank,
  MdOutlineCheckBox,
  MdArrowUpward,
  MdArrowDownward,
  MdOutlinePublish,
  MdReport,
  MdRebaseEdit,
  MdBuildCircle,
  MdCleaningServices,
  MdError,
  MdOutlineManageSearch,
  MdOutlineSettings,
} from 'react-icons/md';
import { BiEditAlt, BiArrowBack } from 'react-icons/bi';
import {
  BsArrowRight,
  BsArrowDown,
  BsArrowUp,
  BsPlus,
  BsCheck2,
  BsChevronDown,
  BsChevronUp,
  BsArrowDownUp,
  BsStopCircle,
  BsPlayCircle,
  BsGrid1X2,
  BsToggles,
} from 'react-icons/bs';
import { IoCloseOutline } from 'react-icons/io5';
import {
  AiOutlineUnlock,
  AiOutlineLock,
  AiOutlineDown,
  AiOutlineRight,
  AiOutlineBorderInner,
  AiOutlineFieldTime,
} from 'react-icons/ai';

import { FiAlertCircle } from 'react-icons/fi';
import {
  FaChartArea,
  FaUserAlt,
  FaShoppingCart,
  FaRegHandPointRight,
  FaRobot,
  FaCheckCircle,
} from 'react-icons/fa';
import {
  AiOutlinePlus,
  AiOutlineArrowRight,
  AiOutlineArrowLeft,
  AiOutlinePause,
  AiOutlinePlayCircle,
  AiOutlineSound,
  AiOutlineWarning,
  AiOutlineInbox,
  AiOutlineLink,
  AiOutlineUserAdd,
  AiOutlineUserDelete,
  AiOutlineEye,
  AiOutlinePhone,
  AiOutlineDollar,
  AiOutlineDelete,
  AiOutlineDoubleRight,
  AiOutlineDownload,
  AiOutlineUpload,
  AiOutlineMinus,
  AiOutlineSend,
  AiOutlineFileText,
  AiOutlineFormatPainter,
} from 'react-icons/ai';
import * as AIIcon from 'react-icons/ai';
import { IoCloseSharp, IoTrendingUpOutline, IoTrendingDownOutline } from 'react-icons/io5';
import { GoFile, GoChecklist } from 'react-icons/go';
import { GrGallery } from 'react-icons/gr';
import { HiOutlineLockClosed, HiOutlineLockOpen } from 'react-icons/hi';
import { DiGoogleAnalytics } from 'react-icons/di';
import { ImFileMusic, ImTable } from 'react-icons/im';
import { VscJson } from 'react-icons/vsc';

// ri
import { RiRectangleFill } from 'react-icons/ri';

const CommonIcons = {
  ...AIIcon,
  Refresh: MdRefresh,
  Edit: BiEditAlt,
  Add: BsPlus,
  Search: MdOutlineSearch,
  Filter: MdOutlineManageSearch,
  Detail: MdOutlineRemoveRedEye,
  RightArrow: BsArrowRight,
  UpArrow: BsArrowUp,
  DownArrow: BsArrowDown,
  Check: BsCheck2,
  Close: IoCloseOutline,
  Copy: MdContentCopy,
  Lock: AiOutlineLock,
  Unlock: AiOutlineUnlock,
  Download: AiOutlineDownload,
  Back: BiArrowBack,
  Trash: AiOutlineDelete,
  Warning: AiOutlineWarning,
  Tooltip: FiAlertCircle,
  Upload: AiOutlineUpload,
  Plus: AiOutlinePlus,
  Chart: FaChartArea,
  File: GoFile,
  Computer: MdComputer,
  FolderMove: MdDriveFileMoveOutline,
  BoxUnCheck: MdOutlineCheckBoxOutlineBlank,
  BoxChecked: MdOutlineCheckBox,
  User: FaUserAlt,
  ArrowDown: BsChevronDown,
  ArrowUp: BsChevronUp,
  SortUp: MdArrowUpward,
  SortDown: MdArrowDownward,
  SortUpDown: BsArrowDownUp,
  Active: BsCheck2,
  Deactivate: IoCloseSharp,
  ShoppingCart: FaShoppingCart,
  RightHandPoint: FaRegHandPointRight,
  Expand: AiOutlineDown,
  Collapse: AiOutlineRight,
  ArrowRight: AiOutlineArrowRight,
  ArrowLeft: AiOutlineArrowLeft,
  ErrorTracker: DiGoogleAnalytics,

  Pause: AiOutlinePause,
  Play: AiOutlinePlayCircle,
  Gallery: GrGallery,
  Publish: MdOutlinePublish,
  Border: AiOutlineBorderInner,

  PlayMusic: BsPlayCircle,
  StopMusic: BsStopCircle,
  Sound: AiOutlineSound,

  LockOpen: HiOutlineLockOpen,
  LockClose: HiOutlineLockClosed,

  TrendUp: IoTrendingUpOutline,
  TrendDown: IoTrendingDownOutline,
  Robot: FaRobot,
  Report: MdReport,
  ChangeStatus: MdRebaseEdit,
  BuildCircle: MdBuildCircle,
  Inbox: AiOutlineInbox,

  AudioTranscript: ImFileMusic,
  Link: AiOutlineLink,
  AssignUser: AiOutlineUserAdd,
  UnAssignUser: AiOutlineUserDelete,
  Preview: AiOutlineEye,
  Phone: AiOutlinePhone,
  Dollar: AiOutlineDollar,
  Clean: MdCleaningServices,
  JSONIcon: VscJson,

  Continue: AiOutlineDoubleRight,
  CheckList: GoChecklist,
  Minus: AiOutlineMinus,
  Send: AiOutlineSend,
  History: AiOutlineFileText,
  ErrorCircle: MdError,
  CheckCircle: FaCheckCircle,
  Table: ImTable,
  Grid: BsGrid1X2,

  Clock: AiOutlineFieldTime,
  RectangleFill: RiRectangleFill,
  Settings: MdOutlineSettings,
  ToggleSideBar: BsToggles,
  Painter: AiOutlineFormatPainter,
};

export { CommonIcons, CoreUIIcons, Flags, FontAwesome, SimpleLineIcons };
